import React, { useEffect } from "react";

const Warning = props => {

  const { warningTxt, onClose } = props.settings;

  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 2000)
    return () => {
      clearTimeout(timer)
    }
  }, [warningTxt])

  return (
    <>
      <div className="modal">
        <div className="warning-content">
          <div className="warning__top">알림</div>
          <div className="warning__middle"><span>{warningTxt}</span></div>
          <div className="warning__bottom">
          </div>
        </div>
      </div>
    </>
  )
}

export default Warning;